import { createContext, useEffect, useState } from 'react';
import { useContextHook } from 'use-context-hook';
import { getCookie } from '../helpers/common';

import { AuthContext } from './authContext';
import {
  connectionWithSocketServer,
  socketServer,
  disconnectSocket,
} from '../helpers/socketConnection/socketConnection';

const context = {
  socket: null,
};

export const SocketContext = createContext(context);

export function SocketContextProvider(props) {
  const { setSocketData, setExpire, isLoggedIn, setNotification, setUpdateNotification } = useContextHook(
    AuthContext,
    v => ({
      setSocketData: v.setSocketData,
      //   setExpire: v.setExpire,
      isLoggedIn: v.isLoggedIn,
      //   setNotification: v.setNotification,
      //   setUpdateNotification: v.setUpdateNotification,
    }),
  );
  const access_token = getCookie(process.env.REACT_APP_AI_TOKEN_COOKIE);
  const [socket, setSocket] = useState(null);

  //   const handleBusinessUpdate = (data) => {
  //     setSocketData(data)
  //   };

  //   const handleExpire = (data) => {
  //     setExpire(data)
  //   }

  //   const handleUpComingNotifications = data => {
  //     setNotification(data);
  //   };

  //   const updateNotification = (data) => {
  //     if(data) {
  //       setUpdateNotification(prev => prev + 1);
  //     }
  //   };

  useEffect(() => {
    if (access_token && isLoggedIn) {
      connectionWithSocketServer(
        access_token,
        //   handleBusinessUpdate,
        //   handleExpire,
        //   handleUpComingNotifications,
        //   updateNotification,
      );
      const s = socketServer();
      setSocket(s);
    } else {
      disconnectSocket();
      setSocket(null);
    }

    return () => {
      disconnectSocket();
      setSocket(null);
    };
  }, [access_token, isLoggedIn]);
  return <SocketContext.Provider value={{ socket }}>{props.children}</SocketContext.Provider>;
}
